













































































import {
  Component, Vue, Prop, Emit, Watch, PropSync, VModel,
} from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';

@Component
export default class CardTable<T> extends Vue {
  @VModel() readonly selected!: never[];

  @Prop({ required: false }) readonly VtableProps!: Record<string, unknown>;

  @Prop({ default: '' }) readonly title!: string;

  @Prop({ default: () => [] }) readonly items!: T[];

  @Prop({ default: false }) readonly loading!: boolean;

  @Prop() readonly headers!: DataTableHeader[];

  @Prop({ default: 7 }) readonly itemsPerPage!: number;

  @Prop({ default: -1 }) readonly total!: number; // determines if it's server-side or not

  @Prop({ default: 1 }) readonly page!: number;

  @Prop({ default: '' }) readonly sortBy!: string;

  @Prop({ type: Boolean, default: false }) readonly showExpand!: boolean;

  @Prop({ type: Boolean, default: false }) readonly disableTitleLoader!: boolean;

  @Prop({ required: false }) readonly itemKey!: string;

  @PropSync('expanded', { type: Array, required: false }) readonly expandedSync!: T[];

  syncedPage = 1;

  syncedSortBy = [];

  syncedSortDesc = [false];

  pageCount = 0;

  get pageText(): string {
    const itemEnd = this.syncedPage * this.itemsPerPage;
    const total = this.total > 0 ? this.total : this.items.length;
    const normalizedItemEnd = itemEnd > total ? total : itemEnd;
    const itemStart = itemEnd - this.itemsPerPage + 1;
    return `Showing ${itemStart} to ${normalizedItemEnd} of ${total} entries`;
  }

  get isTitleShown(): boolean {
    return this.disableTitleLoader || (!this.loading && !this.disableTitleLoader);
  }

  onToggleSelectAll(payload: { items: []; value: boolean }): void {
    this.$emit('toggle-select-all', payload);
  }

  @Watch('syncedPage', { immediate: true })
  @Emit('update:page')
  emitPage(value: number): number {
    return value;
  }

  @Watch('page', { immediate: true })
  syncPage(page: number): void {
    this.syncedPage = page;
  }

  updatePage(page: number): void {
    this.emitPage(page);
  }

  @Watch('syncedSortBy', { immediate: true })
  @Emit('update:sort-by')
  emitSortBy(value: string[]): string | null {
    let [sortBy] = value;
    if (sortBy) {
      this.syncedSortDesc = [false];
    } else {
      sortBy = '';
      this.syncedSortDesc = [false];
    }
    return sortBy;
  }

  @Watch('syncedSortDesc', { immediate: true })
  @Emit('update:sort-desc')
  emitSortDesc(value: boolean[]): boolean {
    return (value) ? value[0] : false;
  }
}
